import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { z } from 'zod';

import { LogsTab } from '../../../../components/admin/LogsTab';

const searchSchema = z.object({
  page: z.number().int().min(1).optional().default(1),
});

export const Route = createFileRoute('/_auth/admin/logs/')({
  validateSearch: searchSchema,
  component: AdminLogsPage,
});

function AdminLogsPage() {
  const { t } = useTranslation();
  const { page } = Route.useSearch();
  const navigate = Route.useNavigate();

  return (
    <section className="epi-card">
      <div className="epi-card-head">
        <span className="num">{t('admin.logs.cardHead.num')}</span>
        <span className="title">{t('admin.logs.cardHead.title')}</span>
        <span className="meta">{t('admin.logs.cardHead.meta')}</span>
      </div>
      <LogsTab
        page={page}
        onPageChange={(p) => void navigate({ search: () => ({ page: p }) })}
      />
    </section>
  );
}
